export default __webpack_public_path__ + "static/small-8-1ee811a3c87b84b2ada60d22fec5d829.png";